import {Helmet} from "react-helmet-async";
import {
    AspectRatio,
    Box,
    BoxProps,
    Button,
    Card,
    CardProps,
    Container,
    Image,
    ImageProps,
    List,
    ListProps,
    SimpleGrid,
    Stack,
    Text,
    Title,
    TitleProps
} from "@mantine/core";
import AddImg from "../assets/img/add-campaign.png"
import MoneyImg from "../assets/img/money-income.png"
import ShareImg from "../assets/img/share-campaign.png"
import {Link} from "react-router-dom";

const HowItWorksPage = (): JSX.Element => {
    const boxProps: BoxProps = {
        mt: 96,
        mb: 136,
        py: 48
    }

    const titleProps: TitleProps = {
        size: 32,
        weight: 800,
        mb: "xl",
        transform: 'capitalize',
        sx: {lineHeight: '40px'}
    }

    const listProps: Omit<ListProps, 'children'> = {
        size: "sm",
        withPadding: true
    }

    const cardProps: Omit<CardProps, 'children'> = {
        radius: "sm",
        shadow: "md",
        padding: "lg",
        sx: {
            backdropFilter: `blur(16px) saturate(180%)`,
            backgroundColor: `rgba(255, 255, 255, 0.75)`,
            border: `none`,
        }
    }

    const imageProps: ImageProps = {
        height: 160,
        fit: "contain",
        py: "xl"
    }


    return (
        <>
            <Helmet>
                <title>How it works</title>
            </Helmet>
            <Box>
                <Container>
                    <Box {...boxProps} sx={{textAlign: 'center'}}>
                        <Title mb={48} fw={800}>How to Fundraise with FundReach</Title>
                     
                        <Text fw={600} mb={36}>Watch our explainer video.</Text>
                        <AspectRatio ratio={1904 / 768} mx="auto">
                            <iframe
                                width="600"
                                height="400"
                                
                                src="https://www.youtube.com/embed/TBBjpeOEQ3I"
                                title="Baby Shark Dance + More Songs | Compilation for Kids | Pinkfong Baby Shark"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen/>
                        </AspectRatio>

                        <Text> <a href="https://www.youtube.com/embed/AOXrmK6fR5E" target="_blank">Watch Video Tutorial on Youtube</a></Text>
                    </Box>
                    <Box {...boxProps}>
                        <Title {...titleProps} align="center">How FundReach Works</Title>
                        <SimpleGrid
                            cols={3}
                            spacing="lg"
                            breakpoints={[
                                {maxWidth: 'md', cols: 3, spacing: 'md'},
                                {maxWidth: 'sm', cols: 1, spacing: 0},
                            ]}
                        >
                            <Card {...cardProps}>
                                <Card.Section>
                                    <Image src={AddImg} {...imageProps}/>
                                </Card.Section>
                                <Text my="sm" fw={600}>1. Start your fundraiser</Text>
                                <List {...listProps}>
                                    <List.Item>Set your fundraising goal</List.Item>
                                    <List.Item>Tell your story with passion</List.Item>
                                    <List.Item>Add a compelling photo or video</List.Item>
                                  
                                </List>
                            </Card>
                            <Card {...cardProps}>
                                <Card.Section>
                                    <Image src={MoneyImg} {...imageProps}/>
                                </Card.Section>
                                <Text my="sm" fw={600}>2. Share & Get Support</Text>
                                <List {...listProps}>
                                    <List.Item>Spread the word via email & text</List.Item>
                                    <List.Item>Amplify your reach on social media</List.Item>
                                    <List.Item>Engage your community for maximum impact</List.Item>
                                
                                </List>
                            </Card>
                            <Card {...cardProps}>
                                <Card.Section>
                                    <Image src={ShareImg} {...imageProps}/>
                                </Card.Section>
                                <Text my="sm" fw={600}>3. Manage & Withdraw Funds</Text>
                                <List {...listProps}>
                                    <List.Item>Accept donations seamlessly</List.Item>
                                    <List.Item>how gratitude by thanking donors</List.Item>
                                    <List.Item>Withdraw funds securely when you need them</List.Item>
                                </List>
                            </Card>
                        </SimpleGrid>
                    </Box>
                  {/*  <TestimonialsSection boxProps={boxProps} titleProps={titleProps}/>*/}
                    <Box {...boxProps}>
                        <SimpleGrid
                            cols={2}
                            breakpoints={[
                                {maxWidth: 'sm', cols: 1, spacing: 0},
                            ]}
                        >
                            <Card
                                shadow="md"
                                radius="sm"
                                component={Link}
                                to="/campaigns"
                            >
                                <Card.Section>
                                    <Image
                                        src="https://images.unsplash.com/photo-1674574124649-778f9afc0e9c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"/>
                                </Card.Section>
                                <Stack spacing="sm" align="start" mt="md">
                                    <Text size="lg" fw={500}>Make an Impact</Text>
                                    <Button size="md" component={Link} to="/campaigns">Fund Someone</Button>
                                </Stack>
                            </Card>
                            <Card
                                shadow="md"
                                radius="sm"
                                component={Link}
                                to="/create-campaign"
                            >
                                <Card.Section>
                                    <Image
                                        src="https://images.unsplash.com/photo-1593113598332-cd288d649433?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"/>
                                </Card.Section>
                                <Stack spacing="sm" align="start" mt="md">
                                    <Text size="lg" fw={500}>Turn Your Vision into Reality</Text>
                                    <Button size="md">Start Fundraising</Button>
                                </Stack>
                            </Card>
                        </SimpleGrid>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default HowItWorksPage;
